import { ITableColumn } from '../interfaces/ITableColumn';

export const initialSearchTableColumns: ITableColumn[] = [
  { id: 'number', name: 'НОМЕР МЕРОПРИЯТИЯ', sort: '', isSortable: false },
  { id: 'federalLaw', name: 'Федеральный закон', sort: '', isSortable: true },
  { id: 'inn', name: 'ИНН', sort: '', isSortable: false },
  { id: 'ogrn', name: 'ОГРН', sort: '', isSortable: false },
  { id: 'faceName', name: 'НАИМЕНОВАНИЕ ПРОВЕРЯЕМОГО ЛИЦА', sort: '', isSortable: false },
  { id: 'startMonth', name: 'МЕСЯЦ НАЧАЛА ПРОВЕДЕНИЯ КНМ', sort: '', isSortable: true },
  {
    id: 'frguOrgName',
    name: 'НАИМЕНОВАНИЕ ОРГАНА ГОСУДАРСТВЕННОГО КОНТРОЛЯ (НАДЗОРА)',
    sort: '',
    isSortable: false,
  },
  { id: 'prosecName', name: 'НАИМЕНОВАНИЕ ОРГАНА ПРОКУРАТУРЫ', sort: '', isSortable: false },
];
